import { useContext, useMemo, useState } from "react";

import { TableContext } from "@sso/context/tableContext";
import { SearchFieldKeys, SearchParameterKeys, SearchType, TableColumn } from "@sso/types";
import { Flex } from "@sso/ui/FlexBox";

import { TableSearchMenu } from "./TableSeachMenu";
import { TableSearchSelect } from "./TableSeachSelect";
import { TableSearchText } from "./TableSeachText";
import { TableSearchDateRange } from "./TableSearchDateRange";

export const TableSearch = () => {
  const { columns } = useContext(TableContext);
  const searchItems = useMemo(() => (columns ? columns.filter(col => col.search) : []), [columns]);
  const [searchField, setSearchField] = useState<TableColumn>(searchItems[0]);

  const selectedColumn = searchField.actionField || (searchField.field as string);
  const handleChangeSearch = (item: TableColumn) => setSearchField(item);

  if (searchItems.length === 0) {
    return <Flex flexGrow={1} />;
  }

  const renderSearchComponent = () => {
    switch (searchField.search?.type) {
      case SearchFieldKeys.TEXT: {
        const searchProps = searchField.search as Extract<SearchType, { type: SearchFieldKeys.TEXT }>;
        return (
          <TableSearchText
            name={searchField.name}
            column={searchProps.field || selectedColumn}
            nullable={searchProps.nullable || false}
            searchType={searchProps.searchParamaterKey || SearchParameterKeys.CONTAIN}
          />
        );
      }

      case SearchFieldKeys.SELECT: {
        const searchProps = searchField.search as Extract<SearchType, { type: SearchFieldKeys.SELECT }>;
        return (
          <TableSearchSelect
            items={searchProps.options}
            name={searchField.name}
            column={searchProps.field || selectedColumn}
            searchType={searchProps.searchParamaterKey || SearchParameterKeys.EQUAL}
          />
        );
      }

      case SearchFieldKeys.DATE_RANGE: {
        const searchProps = searchField.search as Extract<SearchType, { type: SearchFieldKeys.DATE_RANGE }>;
        return (
          <TableSearchDateRange
            name={searchField.name}
            column={searchProps.field || selectedColumn}
            startDate={searchProps.startDate}
            endDate={searchProps.endDate}
          />
        );
      }
    }
  };

  return (
    <>
      {searchField.search && (
        <Flex position="relative" justify="flex-start" width="100%">
          {renderSearchComponent()}
          {searchItems.length > 1 && (
            <TableSearchMenu searchItems={searchItems} onChangeSearchMenu={handleChangeSearch} />
          )}
        </Flex>
      )}
    </>
  );
};
